<template>
  <div class="spinner" :class="{ 'spinner--design-new': design === 'new' }"></div>
</template>

<script>
export default {
  name: 'AppSpinner',
  props: {
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    }
  }
}
</script>

<style lang="sass" scoped>
.spinner
  position: absolute
  top: calc(50% - 28px)
  left: calc(50% - 28px)
  width: 56px
  height: 56px
  border-radius: 50%
  background: radial-gradient(farthest-side, #77b017 94%, #0000) top/6.4px 6.4px no-repeat, conic-gradient(#0000 30%, #77b017)
  mask: radial-gradient(farthest-side, #0000 calc(100% - 6.4px), #000 0)
  animation: spinner-rotate 0.8s infinite linear

.spinner--design-new
  width: 40px
  height: 40px
  top: calc(50% - 20px)
  left: calc(50% - 20px)
  background: radial-gradient(farthest-side, $ui-blue 94%, #0000) top/5px 5px no-repeat, conic-gradient(#0000 30%, $ui-blue)
  mask: radial-gradient(farthest-side, #0000 calc(100% - 5px), #000 0)

@keyframes spinner-rotate
  100%
    transform: rotate(1turn)

</style>
